module.exports = __webpack_public_path__ + "static/img/conveyor-lift-mk-3_256.f541023.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/conveyor-lift-mk-3_256.png
// module id = oUXm
// module chunks = 0